import { httpClient } from '@/services/http/httpClient'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

type IdeaByStatuses = {
  count: number
  color: string
  percentage: number
}

type IdeaByStatusHttpResponse = {
  Rascunho: IdeaByStatuses
  'Aguardando triagem': IdeaByStatuses
  'Aguardando análise': IdeaByStatuses
  'Ajustes pendentes': IdeaByStatuses
  'Em avaliação': IdeaByStatuses
  'Avaliações concluídas': IdeaByStatuses
  'Aprovada para execução': IdeaByStatuses
  'Em execução': IdeaByStatuses
  Pausada: IdeaByStatuses
  Concluída: IdeaByStatuses
  Recusada: IdeaByStatuses
}

type IdeaReturnByStatus = {
  count: number
  percentage: number
  color: string
}

type IdeaByStatus = {
  Rascunho: IdeaReturnByStatus
  'Aguardando triagem': IdeaReturnByStatus
  'Aguardando análise': IdeaReturnByStatus
  'Ajustes pendentes': IdeaReturnByStatus
  'Em avaliação': IdeaReturnByStatus
  'Avaliações concluídas': IdeaReturnByStatus
  'Aprovada para execução': IdeaReturnByStatus
  'Em execução': IdeaReturnByStatus
  Pausada: IdeaReturnByStatus
  Concluída: IdeaReturnByStatus
  Recusada: IdeaReturnByStatus
}

type IdeasByStatusResponse = {
  ideasByStatus: IdeaByStatus
}

export type GetDashboardIdeasByStatusParams = {
  campaignIds?: string[]
}

async function getDashboardIdeasByStatus({
  campaignIds,
}: GetDashboardIdeasByStatusParams): Promise<IdeasByStatusResponse> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    await new Promise((resolve) => setTimeout(resolve, 1000))

    return {
      ideasByStatus: {
        Rascunho: {
          count: 1,
          percentage: 10,
          color: '#D974B0',
        },
        'Aguardando triagem': {
          count: 2,
          percentage: 20,
          color: '#0073EA',
        },
        'Aguardando análise': {
          count: 3,
          percentage: 30,
          color: '#0073EA',
        },
        'Ajustes pendentes': {
          count: 4,
          percentage: 40,
          color: '#ff6b6b',
        },
        'Em avaliação': {
          count: 5,
          percentage: 50,
          color: '#FF642E',
        },
        'Avaliações concluídas': {
          count: 6,
          percentage: 60,
          color: '#0073EA',
        },
        'Aprovada para execução': {
          count: 7,
          percentage: 70,
          color: '#16C60C',
        },
        'Em execução': {
          count: 8,
          percentage: 70,
          color: '#A25DDC',
        },
        Pausada: {
          count: 9,
          percentage: 10,
          color: '#999999',
        },
        Concluída: {
          count: 10,
          percentage: 70,
          color: '#037F4C',
        },
        Recusada: {
          count: 11,
          percentage: 80,
          color: '#FF0000',
        },
      },
    }
  }

  const { data: ideasByStatus } =
    await httpClient.get<IdeaByStatusHttpResponse>(
      '/ideas/dashboard/idea-by-status',
      {
        params: {
          ...(campaignIds && { campaignIds: JSON.stringify(campaignIds) }),
        },
      },
    )

  const ideaStatusEntries = Object.entries(ideasByStatus).map(
    ([status, { count, color, percentage }]) => ({
      [status]: {
        count,
        color,
        percentage,
      },
    }),
  )

  return {
    ideasByStatus: Object.assign({}, ...ideaStatusEntries),
  }
}

export { getDashboardIdeasByStatus, type IdeaByStatus }
